import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Creatable from "react-select/lib/Creatable";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../fetch";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";
import {buildOptions} from "../utils";
import {uniq} from "lodash";

function MedicinalMarijuanaFormModal() {
  const props = useSelector((state) => {
    return {
      show: state.ui.medicinalMarijuanaModal.show,
      medicinalMarijuana: state.medicinalMarijuana || state.ui.medicinalMarijuanaModal.medicinalMarijuana,
      organizationName: state.organization.name,
      resident: state.resident,
      isStaffApp: state.config.isStaffApp,
      hasDelete: state.current_user.permissions.includes("Delete"),
      hasEdit: state.current_user.permissions.includes("Edit"),
    };
  });
  const dispatch = useDispatch();
  const fetch = useFetch();
  const closeModal = () =>
    dispatch({
      type: "CLOSE_RESOURCE_MODAL",
      payload: { resourceName: "medicinalMarijuana" },
    });
  const updateField = (name, value) =>
    dispatch({
      type: "UPDATE_RESOURCE_FIELD",
      payload: { resourceName: "medicinalMarijuana", name, value },
    });

  const setDefaultStaffAppMetaData = () =>
    sendStaffAppMetaData(props.medicinalMarijuanaTabDefaultMetaData);

  const updateResidentMedicinalMarijuanaAction = () => {
    return (dispatch, getState) => {
      const state = getState();
      return fetch(
        `/organizations/${state.organization.name}/residents/${state.resident.id}/medicinal_marijuana.json`,
        {
          method: "PATCH",
          data: {
            medicinal_marijuana: state.ui.medicinalMarijuanaModal.medicinalMarijuana,
          },
        }
      ).then((data) => {
        dispatch({
          type: "UPDATE_MEDICINAL_MARIJUANA",
          payload: { medicinalMarijuana: data.medicinal_marijuana },
        });
      });
    };
  };

  const updateMedicinalMarijuana = () => {
    dispatch(updateResidentMedicinalMarijuanaAction()).then((data) => {
      if (props.isStaffApp) alert("Medicinal Marijuana changes saved.");
      setDefaultStaffAppMetaData();
      closeModal();
    });
  };

  const { maintenance_card, maintenance_card_for_pain_management, form_of_usage } = props.medicinalMarijuana;
  const formOfUsageOptions = buildOptions(
      uniq(['', 'Edibles', 'Drops'])
  );
  const formOfUsageValue = formOfUsageOptions.find(
      (option) => option.value === form_of_usage
  );
  const options = [{ label: "Yes", value: true }, { label: "No", value: false }];
  const maintenanceCard = options.find((option) => option.value === maintenance_card);
  const maintenanceCardForPainManagement = options.find((option) => option.value === maintenance_card_for_pain_management);

  return (
    <Modal
      animation={!props.isStaffApp}
      show={props.show}
      onHide={() => closeModal()}
    >
      {!props.isStaffApp && (
        <Modal.Header closeButton>
          <Modal.Title>Medicinal Marijuana</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className={props.hasEdit ? "p-4" : "p-4 form-modal-width"}>
        {props.hasEdit ? (
          <>
            <Form.Group controlId="medicinalMarijuanaOther">
              <Form.Label>Maintenance Card</Form.Label>
              <Creatable
                options={options}
                value={maintenanceCard}
                onChange={(option) => {
                  updateField("maintenance_card", option.value);
                }}
              />
            </Form.Group>
            <Form.Group controlId="medicinalMarijuanaOther">
              <Form.Label>Marijuana Maintenance Card For Pain Management</Form.Label>
              <Creatable
                options={options}
                value={maintenanceCardForPainManagement}
                onChange={(option) => {
                  updateField("maintenance_card_for_pain_management", option.value);
                }}
              />
            </Form.Group>
            <Form.Group controlId="medicinalMarijuanaFormOfUsage">
              <Form.Label>Form of Usage</Form.Label>
              <Creatable
                  options={formOfUsageOptions}
                  value={formOfUsageValue}
                  onChange={(option) => {
                    updateField("form_of_usage", option.value);
                  }}
              />
            </Form.Group>
          </>
        ) : (
          <>
            <Form.Group>
              <Form.Label>Maintenance Card</Form.Label>
              <div className="form-control-plaintext">{maintenance_card === true ? 'Yes' : maintenance_card === false ? 'No' : 'N/A'}</div>
            </Form.Group>
            <Form.Group>
              <Form.Label>Marijuana Maintenance Card For Pain Management</Form.Label>
              <div className="form-control-plaintext">{maintenance_card_for_pain_management === true ? 'Yes' : maintenance_card_for_pain_management === false ? 'No' : 'N/A'}</div>
            </Form.Group>
            <Form.Group>
              <Form.Label>Form of Usage</Form.Label>
              <div className="form-control-plaintext">{form_of_usage || 'N/A'}</div>
            </Form.Group>
          </>
        )}
      </Modal.Body>
      {props.hasEdit && (
        <Modal.Footer>
          <Button variant="info" onClick={() => updateMedicinalMarijuana()}>
            Update
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default MedicinalMarijuanaFormModal;
